import React from "react"
import tw from "twin.macro"

interface Props extends React.HTMLProps<HTMLButtonElement> {
  className?: string

  children: React.ReactNode
}

export const Button = React.forwardRef<HTMLButtonElement, Props>(
  ({ className, children, ...props }, ref) => {
    return (
      <StyledButton className={className} ref={ref} {...props}>
        {children}
      </StyledButton>
    )
  }
)

const StyledButton = tw.button`px-8 py-2 border-2 border-black focus:outline-none hover:bg-black hover:text-white transition-colors duration-200 ease-in-out`
